import * as React from 'react';
import { AttendanceResponseDTO } from '../../../ApiOld/ApiServerVov';
import { Box, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TimeFromMinutes from '../../Shared/Functions/TimeFromMinutes';
import ActivityStringHelper from './Helpers/ActivityStringHelper';

export interface IMobileAttendanceNonworkTabProps {
    data: AttendanceResponseDTO[];
}

export default function MobileAttendanceNonworkTab(props: IMobileAttendanceNonworkTabProps) {
    const { data } = props;
    const { t } = useTranslation();

    const getDaysHoliday = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => (p.actions && p.actions.length > 0))
            .flatMap(p => p.actions)
            .filter(p => p?.type === "6")
            .forEach((item) => {
                minutes += item?.minutes ?? 0;
            });

        return Math.floor(minutes / (60 * 8)).toString(); // Whole days
    };

    const getWholeHoursHoliday = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => p.actions && p.actions.length > 0)
            .flatMap(p => p.actions)
            .filter(p => p?.type === "6")
            .forEach((item) => {
                minutes += item?.minutes ?? 0;
            });

        const remainingMinutes = minutes % (60 * 8);
        return Math.floor(remainingMinutes / 60); // Get whole hours
    };

    const getDecimalMinutesHoliday = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => p.actions && p.actions.length > 0)
            .flatMap(p => p.actions)
            .filter(p => p?.type === "6")
            .forEach((item) => {
                minutes += item?.minutes ?? 0;
            });

        const remainingMinutes = minutes % (60 * 8);
        return Math.round((remainingMinutes / 60) * 10); // Convert to decimal (e.g., 30 min = 5)
    };

    const getDaysDocIllness = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => (p.actions && p.actions.length > 0)).flatMap(p => p.actions).filter(p => p?.type === "5" || p?.type === "7").forEach((item) => {
            minutes += item?.minutes ?? 0;
        });

        return Math.floor(minutes / (60 * 8)).toString(); // Whole days
    }

    const getWholeHoursDocIllness = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        console.log(data);
        data.filter(p => (p.actions && p.actions.length > 0)).flatMap(p => p.actions).filter(p => p?.type === "5" || p?.type === "7").forEach((item) => {
            minutes += item?.minutes ?? 0;
        });

        const remainingMinutes = minutes % (60 * 8);
        return (Math.round(remainingMinutes / 60)).toString();
    }

    const getDecimalMinutesIllness = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => (p.actions && p.actions.length > 0)).flatMap(p => p.actions).filter(p => p?.type === "5" || p?.type === "7").forEach((item) => {
            minutes += item?.minutes ?? 0;
        });


        const remainingMinutes = minutes % (60 * 8);
        return Math.round((remainingMinutes / 60) * 10); // Convert to decimal (e.g., 30 min = 5)
    };

    /* const getMinutesHoliday = (data: AttendanceResponseDTO[]) => {
        let minutes = 0;
        data.filter(p => (p.actions && p.actions.length > 0)).flatMap(p => p.actions).filter(p => p?.type === "6").forEach((item) => {
            minutes += item?.minutes ?? 0;
        });
        const result = minutes % 60;
        return result.toString().padStart(2, '0');
    } */

    const decimalMinutesHoliday = getDecimalMinutesHoliday(data);
    const decimalMinutesIllness = getDecimalMinutesIllness(data);

    return (
        <Grid container sx={{
            flex: 1, p: 1, height: 'calc(100vh - 245px)'
        }}>
            < Grid item xs={12} >
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={1}
                >

                    <Box
                        sx={{
                            background: 'white',
                            p: 1,
                            boxShadow: 3,
                            borderRadius: '10px',
                            flex: 1 // Takes half of the available space
                        }}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <Typography fontWeight="bold">{t('holiday')}</Typography>
                            <Stack direction="row">
                                <Typography variant="h3" color="#FFC600">{getDaysHoliday(data)}</Typography>
                                <Typography variant="h6" color="#FFC600" marginTop="21px">{'d'}</Typography>
                                <Typography variant="h3" color="#FFC600" ml={1}>{getWholeHoursHoliday(data)}</Typography>
                                {decimalMinutesHoliday > 0 && <Typography variant="h6" color="#FFC600" marginTop="21px">{'.'}</Typography>}
                                {decimalMinutesHoliday > 0 && <Typography variant="h6" color="#FFC600" marginTop="21px">{decimalMinutesHoliday}</Typography>}
                                <Typography variant="h6" color="#FFC600" marginTop="21px">{'h'}</Typography>
                            </Stack>
                        </Stack>
                    </Box>

                    <Box
                        sx={{
                            background: 'white',
                            p: 1,
                            boxShadow: 3,
                            borderRadius: '10px',
                            flex: 1 // Takes half of the available space
                        }}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Stack direction="column" justifyContent="center" alignItems="center">
                            <Typography fontWeight="bold">{t('doctorIllness')}</Typography>
                            <Stack direction="row">
                                <Typography variant="h3" color="#FFC600">{getDaysDocIllness(data)}</Typography>
                                <Typography variant="h6" color="#FFC600" marginTop="21px">{'d'}</Typography>
                                <Typography variant="h3" color="#FFC600" ml={1}>{getWholeHoursDocIllness(data)}</Typography>
                                {decimalMinutesIllness > 0 && <Typography variant="h6" color="#FFC600" marginTop="21px">{'.'}</Typography>}
                                {decimalMinutesIllness > 0 && <Typography variant="h6" color="#FFC600" marginTop="21px">{decimalMinutesIllness}</Typography>}
                                <Typography variant="h6" color="#FFC600" marginTop="21px">{'h'}</Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </Box>

                <Box sx={{ background: 'white', p: 1, boxShadow: 3, borderRadius: '10px', width: '100%', marginTop: '16px', marginBottom: '8px' }} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 300, border: 'none' }} aria-label="simple table">
                            <TableHead sx={{ borderBottom: '1px solid lightgray' }}>
                                <TableRow>
                                    <TableCell sx={{ border: 'none' }}>{t('Date')}</TableCell>
                                    <TableCell sx={{ border: 'none' }} align="right">{t('log.hours')}</TableCell>
                                    <TableCell sx={{ border: 'none' }}>{t('activity')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.filter(p => (p.actions && p.actions.length > 0)).flatMap(p => p.actions).map((row) => (
                                    <TableRow
                                        key={row!.dateTime?.toString()}
                                    /* sx={{ '&:last-child td, &:last-child th': { border: 0 } }} */
                                    >
                                        <TableCell sx={{ border: 'none', borderBottom: '1px solid lightgray', width: '150px' }} component="th" scope="row">
                                            {row!.dateTime?.toLocaleDateString(undefined, {
                                                weekday: 'short',
                                                /* year: 'numeric', */
                                                month: '2-digit',
                                                day: '2-digit',
                                            })}
                                        </TableCell>
                                        <TableCell sx={{ border: 'none', borderBottom: '1px solid lightgray', width: '100px' }} align="right" >{TimeFromMinutes(row!.minutes ?? 0)}</TableCell>
                                        <TableCell sx={{ border: 'none', borderBottom: '1px solid lightgray', width: '120px' }} >{ActivityStringHelper(row!.type!)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Grid>
        </ Grid >);
}
